import React from 'react';

import styles from './styles.module.scss';

const Skeleton: React.FunctionComponent = () => {
  return (
    <React.Fragment>
      <span data-nosnippet className="visuallyHidden">
        Loading subscription renewal date
      </span>
      <div className={styles.skeleton} aria-hidden="true">
        <p></p>
        <span></span>
      </div>
    </React.Fragment>
  );
};

export default Skeleton;
